import DatePicker, { registerLocale } from "react-datepicker";
import { th as thBuddhist } from 'date-fns/esm/locale';
import th from 'date-fns/locale/th';
import "./DatePickerInputStyle.css"
import { RenderCustomHeader } from "./RenderCustomHeader";
import { ConvertDateFormat } from "./ConvertDateFormat";
import { ConvertDateToThaiBuddhist } from "./ConvertDateToThaiBuddhist";
import { Input } from "reactstrap";
import 'react-datepicker/dist/react-datepicker.css'
import "./form.css"
registerLocale('th-buddhist', { ...th, options: { ...th.options, weekStartsOn: 1 }, formatLong: thBuddhist.formatLong })

export const DatePickerInput = (props) => {
    return (
        <DatePicker
            {...props.field}
            selected={props.field.value ? new Date(props.field.value) : null}
            locale="th-buddhist"
            calendarClassName="thai-buddhist"
            minDate={props.minDate !== undefined ? props.minDate : null}
            maxDate={props.maxDate !== undefined ? props.maxDate : null}
            isClearable={props.disable !== undefined ? !props.disable : !false}
            disabled={props.disable !== undefined ? props.disable : false}
            dateFormat="dd MMMM yyyy"
            value={ConvertDateToThaiBuddhist(props.field.value)}
            placeholderText="กรุณาเลือก"
            renderCustomHeader={RenderCustomHeader}
            onChange={(date) => {
                props.form.setFieldValue(props.field.name, ConvertDateFormat(date))
            }}
            customInput={
                <Input
                    type="text"
                    className={
                        props.form.touched[props.field.name] && props.form.errors[props.field.name]
                            ? `input-error rounded-pill text-center input-color custom-placeholder`
                            : `rounded-pill text-center input-color custom-placeholder`
                    }
                    value={ConvertDateToThaiBuddhist(props.field.value)}
                    onChange={() => { }}
                    onBlur={props.field.onBlur}
                />
            }
        />
    )

}